import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";

import { useStyles } from "./Login.css";
import Background from "../../../../Assets/Images/background.jpg";
import LoginSignUpTab from "../LoginSignUpTab";
import AuthorLogin from "./AuthorLogin/AuthorLogin";
import CustomerLogin from "./CustomerLogin/CustomerLogin";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: this.props.match.params.type,
    };
  }

  handleCurrentPage = (e, newValue) => {
    this.setState({
      currentPage: newValue,
    });
  };

  showLoginPage = (page) => {
    switch (page) {
      case "Customer":
        return <CustomerLogin />;

      case "Author":
        return <AuthorLogin />;

      default:
        break;
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div
        className={classes.root}
        style={{
          background: `url(${Background})`,
        }}
      >
        <LoginSignUpTab
          currentPage={this.state.currentPage}
          handleCurrentPage={this.handleCurrentPage}
        />
        <br />
        {this.showLoginPage(this.state.currentPage)}
      </div>
    );
  }
}

export default withStyles(useStyles)(Login);
